import { tw } from 'utils/classnames'
import { StarIcon } from 'primitives/icons/star'

interface RatingProps {
  disabled?: boolean
  readOnly?: boolean
  value?: number
  className?: string
  onChange?: (value: number) => void
}

export function Rating({ value, readOnly, className }: RatingProps) {
  const maxCheckedStar = Math.floor(value || 0)

  return (
    <div className={tw('relative inline-flex', className)}>
      {[1, 2, 3, 4, 5].map(starIndex => {
        return (
          <Star
            className={tw('h-full', !readOnly && 'cursor-pointer')}
            key={starIndex}
            checked={starIndex <= maxCheckedStar}
          />
        )
      })}
    </div>
  )
}

export type StarProps = React.HTMLProps<HTMLLabelElement>

export function Star({ className, checked }: StarProps) {
  return (
    <label className={tw('flex aspect-square items-center', className)}>
      <StarIcon
        className={tw(
          'size-full',
          checked ? 'text-[#F9A050]' : 'text-cf-dreamy-cloud-700',
          'transition-transform ease-out ',
        )}
        checked={checked}
      />
    </label>
  )
}
